import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { UiCheckboxModule } from '../checkbox/checkbox.module';
import { MulticomboboxComponent } from './multicombobox.component';

@NgModule({
  declarations: [MulticomboboxComponent],
  imports: [FormsModule, ReactiveFormsModule, CommonModule, NgbDropdownModule, UiCheckboxModule],
  exports: [MulticomboboxComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UiMulticomboboxModule {}
